document.addEventListener("DOMContentLoaded",function (){
    (function (){
        const pointerTextList = document.querySelectorAll('.yg-banner-name');

        // 创建一个空数组来存储文本内容
        const textArray = [];
        pointerTextList.forEach(function (pointerText){
            textArray.push(pointerText.innerText)
        })
        function Movepointer(){
            const pointer = document.querySelector(".swiper-pagination-bullet")
            let marginTop = (this.realIndex - 1) * (pointer.offsetHeight) * -1
            pointer.style.marginTop= marginTop+"px"
            // 如果active为第一项
            if(this.realIndex === 0){
                pointer.parentElement.classList.add("yg-first-item");
                pointer.style.marginTop= 0+"px"
            } else {
                pointer.parentElement.classList.remove("yg-first-item");
            }
            // 如果active为最后一项
            if(this.realIndex === this.slides.length - 1){
                pointer.parentElement.classList.add("yg-last-item");
            } else {
                pointer.parentElement.classList.remove("yg-last-item");
            }
        }
        const swiper = document.querySelector('.yg-swiper-banner-list')
        
        new Swiper(".yg-swiper-banner-list", {
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    return `<li class="${className}">
                    <div class="yg-progress-bar">
                        <div class="yg-progress-bar-inner"></div>
                    </div>
                    <span class="yg-progress-bar-text">${textArray[index]}</span>
                    </li>`;
                }

            },
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on:{
                //滑块结束后触发事件
                slideChangeTransitionEnd: Movepointer
            },
            autoplay: swiper.getAttribute("data-autoplay") ? {delay: 5000,disableOnInteraction: false,} : false,
        });

        const pointerHeight = swiper.querySelector(".swiper-pagination-bullet").offsetHeight;
        console.log("pointerHeight",pointerHeight);
        swiper.style.setProperty("--swiper-pagination-height", pointerHeight * 3 + "px");


    }())
})